$(document).ready(function(){
    $('.loox-rating').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#looxReviews').offset().top - 100
        }, 800);
    });
    $(document).on('click', '#faq-list .faq-q', function(e) {
        e.preventDefault();

        var $item = $(this).closest('.faq-item');
        var open = $item.attr('aria-expanded') === 'true';

        $item.attr('aria-expanded', !open);

        var $answer = $item.find('.faq-a');

        if (open) {
            $answer.css('max-height', '0');
        } else {
            $answer.css('max-height', $answer[0].scrollHeight + 'px');
        }
    });

    $(document).on('click', '#buyFaq .bfq', function (e) {
        e.preventDefault();

        var $item = $(this).closest('.bfi');
        var isOpen = $item.attr('aria-expanded') === 'true';
        var $answer = $item.find('.bfa');

        $item.attr('aria-expanded', !isOpen);

        if (isOpen) {
            $answer.css('max-height', '0');
        } else {
            $answer.css('max-height', $answer[0].scrollHeight + 'px');
        }
    });
    $(document).on('click', '#openSize', function () {
        $('#sizeModal').addClass('show');
        $('#backdrop').addClass('show');
    });
    $(document).on('click', '#closeSize', function () {
        $('#sizeModal').removeClass('show');
        $('#backdrop').removeClass('show');
    });
})